import { Box, Button, Fade, Modal, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

import { getModalStyle } from '@/lib/style/modal';

interface Props {
    open: boolean;
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    showCancel?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const ConfirmationModal = ({
    cancelLabel,
    confirmLabel,
    message,
    onCancel,
    onConfirm,
    open,
    showCancel = true,
    title,
}: Props) => {
    const modalStyle = useMemo(() => getModalStyle(), []);

    return (
        <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Fade in={open}>
                <Box sx={modalStyle}>
                    <Stack spacing={3}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {title}
                        </Typography>

                        <Typography id="modal-modal-description" component="div">
                            {message}
                        </Typography>

                        <Stack
                            direction="row"
                            sx={{
                                justifyContent: 'space-between',
                                flexDirection: 'row-reverse',
                            }}
                        >
                            <Button variant="contained" type="submit" onClick={onConfirm}>
                                {confirmLabel ?? 'OK'}
                            </Button>
                            {showCancel && (
                                <Button variant="text" onClick={onCancel}>
                                    {cancelLabel ?? 'Cancel'}
                                </Button>
                            )}
                        </Stack>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    );
};
